import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'

export interface SheetExportRow {
  title: string
  status: string
  assignee?: string
  dueDate?: string
  notes?: string
}

export interface ExportChecklistToGoogleSheetInput {
  workspaceId: string
  connectionId: string
  title: string
  rows: SheetExportRow[]
  spreadsheetId?: string
}

export interface ExportChecklistToGoogleSheetOutput {
  spreadsheetId: string
  spreadsheetUrl: string
  rowCount: number
}

export interface GoogleSheetsPickerTokenOutput {
  accessToken: string
  expiresInSeconds: number
}

const callable = <I, O>(name: string) => httpsCallable<I, O>(firebaseFunctions, name)

export const parseSpreadsheetIdFromUrl = (url: string): string | null => {
  if (!url) return null
  const trimmed = url.trim()
  // Match standard Google Sheets URLs: /spreadsheets/d/{spreadsheetId}
  const match = trimmed.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/)
  if (match?.[1]) return match[1]
  // If user pasted raw spreadsheet ID
  if (/^[a-zA-Z0-9-_]{20,}$/.test(trimmed)) return trimmed
  return null
}

export const getGoogleSheetsPickerToken = async (connectionId: string): Promise<GoogleSheetsPickerTokenOutput> => {
  const result = await callable<{ connectionId: string }, GoogleSheetsPickerTokenOutput>('getGoogleSheetsPickerToken')({ connectionId })
  return result.data
}

export const exportChecklistToGoogleSheet = async (
  input: ExportChecklistToGoogleSheetInput,
): Promise<ExportChecklistToGoogleSheetOutput> => {
  const result = await callable<ExportChecklistToGoogleSheetInput, ExportChecklistToGoogleSheetOutput>('exportChecklistToGoogleSheet')(input)
  return result.data
}
